module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/client-detail/client-detail-main/client-detail-main.component.scss
// module id = ./src/app/clients/client-detail/client-detail-main/client-detail-main.component.scss
// module chunks = main